import { createBrowserRouter, Navigate } from 'react-router-dom'

import { SidebarProvider } from '@/components/layout'
import { AuthProvider } from '@/contexts'

import { NotFoundPage } from './ErrorPages/NotFoundPage'
import { adminRoutes } from './routes/admin.routes'
import { assessmentProcessRoutes, assessmentRoutes } from './routes/assessment.routes'
import { authRoutes } from './routes/auth.routes'
import { dashboardRoutes } from './routes/dashboard.routes'
import { profileRoutes } from './routes/profile.routes'
import { testRoutes } from './routes/test.routes'
import { ProtectedRoute } from './ProtectedRoute'

export const router = createBrowserRouter([
  // Authentication routes
  authRoutes,

  // Main application routes
  {
    path: '/',
    element: (
      <AuthProvider>
        <SidebarProvider>
          <ProtectedRoute />
        </SidebarProvider>
      </AuthProvider>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />
      },
      dashboardRoutes,
      profileRoutes,
      assessmentRoutes,
      adminRoutes
    ]
  },

  // Assessment process routes (protected, with dedicated layout)
  {
    path: '/',
    element: (
      <AuthProvider>
        <ProtectedRoute />
      </AuthProvider>
    ),
    children: [assessmentProcessRoutes]
  },

  // Test routes (should be wrapped with auth providers)
  {
    path: '/test',
    element: (
      <AuthProvider>
        <SidebarProvider>
          <ProtectedRoute />
        </SidebarProvider>
      </AuthProvider>
    ),
    children: testRoutes.children
  },

  // 404 catch-all
  {
    path: '*',
    element: <NotFoundPage />
  }
])
